import { render, staticRenderFns } from "./PlaylistCoach.vue?vue&type=template&id=1945237a&scoped=true"
import script from "./PlaylistCoach.vue?vue&type=script&lang=js"
export * from "./PlaylistCoach.vue?vue&type=script&lang=js"
import style0 from "./PlaylistCoach.vue?vue&type=style&index=0&id=1945237a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945237a",
  null
  
)

export default component.exports